// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"bcae55e5","453":"10789395","468":"c70f8318","677":"770f9dfe","762":"7951eaaa"}[chunkId] + ".chunk.js";
};